import { Component, Inject, OnInit, ViewChild, EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_228';

const stepsList = [
  { text: "1", active: false, completed: false, tooltip: 'Valor Costos y Gastos para deducir', listHelp: ['744'] }];


const tableStructure = [
  {id: 'nombreRenta', title: 'Renta'},
  {id: 'valDeclarar', title: 'Valor'},
];

class ValoresDominio {
  valor: number;
  nombre: string;
  mostrar: boolean;
}

class Form1 {
id: number;
renta:number;
nombreRenta:string;
valDeclarar:string;
}
@Component({
  selector: 'app-impuesto-renta-impto-renta-costos-y-gastos-para-deducir-modal',
  templateUrl: './impto-renta-costos-y-gastos-para-deducir-modal.component.html',
  styleUrls: ['./impto-renta-costos-y-gastos-para-deducir-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class ImpuestoRentaTuvoCostosyGastosaDeducirModalComponent extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
 // public lstArticulos: ArticulosDominio[] = [];
  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3;
  public operacionTabla:number = this.OPERACION_NULA;
  casillaLimpiada: boolean = false;
  
  mensajeTabla = "Agregue, edite o elimine sus costos y gastos para deducir.";

  listaTipoRentaCostosGastosDeducibles: any;

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;
  nuevaListaRenta: ValoresDominio[] = [];

  constructor(
    public dialogRef: MatDialogRef<ImpuestoRentaTuvoCostosyGastosaDeducirModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio,
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) {
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();

    this.filtroLisTipRenta();
  }

  protected filtroLisTipRenta(){


    const valoresPermitidos = ['2', '3', '4'];
 
    this.listaTipoRentaCostosGastosDeducibles.forEach(item => {
      item.mostrar = valoresPermitidos.includes(item.valor);
    });
 
    this.nuevaListaRenta = this.listaTipoRentaCostosGastosDeducibles.filter(item => item.mostrar);

  }




  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.renta=0;
    this.modelForm.nombreRenta="";
    this.modelForm.valDeclarar="0";
  //  this.reloadSelArticulos();
  }

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_747 == undefined){

      this.model.doc.cuerpo.cc_id_746 = [];  //Tipo de Renta
      this.model.doc.cuerpo.cc_id_747 = [];  //Valor Item
      this.model.doc.cuerpo.cs_id_748 = "0"; //Valor Total

    }
  }

//   protected reloadSelArticulos(conservarArt?:boolean){//Dom 1649

//     this.lstArticulos[0] = {valor:0,nombre:""};
//     this.lstArticulos[1] = {valor:1,nombre:"Valor de compra: "+this.modelForm.valCompra};
//     this.lstArticulos[2] = {valor:2,nombre:"Valor declarado año anterior: "+this.modelForm.valDeclaradoAnioAnterior};
//     this.lstArticulos[3] = {valor:3,nombre:"Reajuste Art. 70: "+this.modelForm.valReajuste};

//     if(!conservarArt)this.modelForm.art=0;
//   }

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_747.length; i++){
      this.modelForm.id=i;
      this.modelForm.renta=this.model.doc.cuerpo.cc_id_746[i].v;
      if (this.listaTipoRentaCostosGastosDeducibles[this.model.doc.cuerpo.cc_id_746[i].v - 1])
        this.modelForm.nombreRenta = this.listaTipoRentaCostosGastosDeducibles[this.model.doc.cuerpo.cc_id_746[i].v - 1].nombre;
      //this.modelForm.nombreRenta= this.listaTipoRentaCostosGastosDeducibles[ this.model.doc.cuerpo.cc_id_746[i].v].nombre;
      this.modelForm.valDeclarar=this.model.doc.cuerpo.cc_id_747[i].v;

      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
    this.operacionCs748();
  }

  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_746[this.modelForm.id].v=this.modelForm.renta.toString();
    this.model.doc.cuerpo.cc_id_747[this.modelForm.id].v=this.modelForm.valDeclarar.toString();

    this.operacionCs748();
  }

  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_746.push({it: i, v:this.modelForm.renta});
    this.model.doc.cuerpo.cc_id_747.push({it: i, v:this.modelForm.valDeclarar.toString()});

    this.operacionCs748();
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_746.splice(index,1);
    this.model.doc.cuerpo.cc_id_747.splice(index,1);

    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_747.length;i++){
      this.model.doc.cuerpo.cc_id_746[i].it=i+1;
      this.model.doc.cuerpo.cc_id_747[i].it=i+1;
    }
    this.operacionCs748();
  }

  public validateFormCompleted():boolean{
    return this.modelForm.renta==undefined || this.modelForm.renta== null ||
    this.modelForm.valDeclarar==undefined || this.modelForm.valDeclarar==""
  }

  public redondearFormData(){
    this.modelForm.valDeclarar=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(),true);

  }

  public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();

  }


  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        //this.editModeloDesdeForm();
        this.modelForm.nombreRenta = this.listaTipoRentaCostosGastosDeducibles.find((elemento: { valor: any; }) => elemento.valor === this.modelForm.renta).nombre;
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });

      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        // this.modelForm.id = this.dataSourceBody.length;
        this.modelForm.id = this.model.doc.cuerpo.cc_id_747.length;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
        this.modelForm.nombreRenta = this.listaTipoRentaCostosGastosDeducibles.find((elemento: { valor: any; }) => elemento.valor === this.modelForm.renta).nombre;
      }
      //Recalcular y reinicializar
      this.operacionCs748();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
      console.log(this.model);
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs748();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
    //  this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }



  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 152:
        this.operacionCs748();
        break;
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";

    //C151=C149-C153+C154+C155;
    resultado = "0";
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.model.doc.cuerpo.cs_id_149,this.model.doc.cuerpo.cs_id_153, true);
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_154, true);
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_155, true);
    resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0")?"0":resultado;
    this.model.doc.cuerpo.cs_id_151 = this.dutilidades.redondearValorMoneda(resultado,true);

  }

  operacionCs748(){
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valDeclarar, suma);
    }
    this.model.doc.cuerpo.cs_id_748 = suma;

  }

  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }



  protected controlStep(direction: DirectionType): void {

  }

  limpiarValor() {
    if (this.modelForm.valDeclarar === '0' && !this.casillaLimpiada) {
      this.modelForm.valDeclarar = null;
      this.casillaLimpiada = true;
    }
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.operacionCs748();
    //this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    this.model.doc.cuerpo.cc_id_747 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }

    this.operacionCs748()
    this.saveModel.emit(true);
    this.closeModal();

  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/impuesto-renta/impto-renta-costos-y-gastos-para-deducir-modal/impto-renta-costos-y-gastos-para-deducir-modal.component.ts